import React from "react";
import {
  Box,
  Typography,
  Paper,
  TextField,
  Grid,
  Alert,
  Button,
} from "@mui/material";
import { Search as SearchIcon, Add as AddIcon } from "@mui/icons-material";
import { FormattedMessage, useIntl } from "react-intl";
import TypesList from "./TypesList/TypesList";
import DeleteTypeDialog from "./DeleteTypeDialog/DeleteTypeDialog";
import EditTypeDialog from "./EditTypeDialog/EditTypeDialog";
import CreateTypeDialog from "./CreateTypeDialog/CreateTypeDialog";
import { useTypeManagement } from "./useTypeManagement";

export const TypeManagement: React.FC = () => {
  const intl = useIntl();
  const {
    types,
    totalTypes,
    error,
    deleteDialogOpen,
    editDialogOpen,
    createDialogOpen,
    typeToEdit,
    page,
    rowsPerPage,
    orderBy,
    order,
    searchTerm,
    deleteError,
    fetchTypeData,
    handleDeleteType,
    confirmDeleteType,
    handleEditType,
    handleUpdateType,
    handleCreateType,
    handleChangePage,
    handleChangeRowsPerPage,
    handleRequestSort,
    handleSearchChange,
    setDeleteDialogOpen,
    setEditDialogOpen,
    setCreateDialogOpen,
    setTypeToEdit,
    setDeleteError,
  } = useTypeManagement();

  React.useEffect(() => {
    fetchTypeData();
  }, [fetchTypeData]);

  return (
    <Box>
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}
      <Paper sx={{ width: "100%", mb: 2 }}>
        <Box sx={{ p: 2 }}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} sm={6}>
              <Typography variant="h6" component="div">
                <FormattedMessage id="admin.dashboard.types" />
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <SearchIcon sx={{ mr: 1 }} />
                <TextField
                  variant="outlined"
                  size="small"
                  placeholder={intl.formatMessage({
                    id: "admin.dashboard.searchPlaceholder",
                  })}
                  value={searchTerm}
                  onChange={handleSearchChange}
                  fullWidth
                />
              </Box>
            </Grid>
          </Grid>
        </Box>
        <Box sx={{ p: 2 }}>
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={() => setCreateDialogOpen(true)}
          >
            <FormattedMessage id="admin.dashboard.createType" />
          </Button>
        </Box>
        <TypesList
          types={types}
          totalTypes={totalTypes}
          page={page}
          rowsPerPage={rowsPerPage}
          orderBy={orderBy}
          order={order}
          onRequestSort={handleRequestSort}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
          onEditType={handleEditType}
          onDeleteType={handleDeleteType}
        />
      </Paper>
      <DeleteTypeDialog
        open={deleteDialogOpen}
        onClose={() => {
          setDeleteDialogOpen(false);
          setDeleteError(null);
        }}
        onConfirm={confirmDeleteType}
        error={deleteError}
      />
      <EditTypeDialog
        open={editDialogOpen}
        typeToEdit={typeToEdit}
        onClose={() => setEditDialogOpen(false)}
        onSave={handleUpdateType}
        onTypeChange={setTypeToEdit}
      />
      <CreateTypeDialog
        open={createDialogOpen}
        onClose={() => setCreateDialogOpen(false)}
        onSave={handleCreateType}
      />
    </Box>
  );
};
